module.exports = __webpack_public_path__ + "img/avatar001.429f79b4.jpg";